// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Marketplace } from './Marketplace';
import {
  MarketplaceFromJSON,
  MarketplaceFromJSONTyped,
  MarketplaceToJSON,
  MarketplaceToJSONTyped,
} from './Marketplace';
import type { BillingAccountID } from './BillingAccountID';
import {
  BillingAccountIDFromJSON,
  BillingAccountIDFromJSONTyped,
  BillingAccountIDToJSON,
  BillingAccountIDToJSONTyped,
} from './BillingAccountID';

/**
 *
 * @export
 * @interface FindMarketplaceResponse
 */
export interface FindMarketplaceResponse {
  /**
   *
   * @type {Marketplace}
   * @memberof FindMarketplaceResponse
   */
  marketplace: Marketplace;
  /**
   *
   * @type {BillingAccountID}
   * @memberof FindMarketplaceResponse
   */
  billingAccount?: BillingAccountID;
}

/**
 * Check if a given object implements the FindMarketplaceResponse interface.
 */
export function instanceOfFindMarketplaceResponse(
  value: object,
): value is FindMarketplaceResponse {
  if (!('marketplace' in value) || value['marketplace'] === undefined)
    return false;
  return true;
}

export function FindMarketplaceResponseFromJSON(
  json: any,
): FindMarketplaceResponse {
  return FindMarketplaceResponseFromJSONTyped(json, false);
}

export function FindMarketplaceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FindMarketplaceResponse {
  if (json == null) {
    return json;
  }
  return {
    marketplace: MarketplaceFromJSON(json['marketplace']),
    billingAccount:
      json['billingAccount'] == null
        ? undefined
        : BillingAccountIDFromJSON(json['billingAccount']),
  };
}

export function FindMarketplaceResponseToJSON(
  json: any,
): FindMarketplaceResponse {
  return FindMarketplaceResponseToJSONTyped(json, false);
}

export function FindMarketplaceResponseToJSONTyped(
  value?: FindMarketplaceResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    marketplace: MarketplaceToJSON(value['marketplace']),
    billingAccount: BillingAccountIDToJSON(value['billingAccount']),
  };
}
